import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/en/ai-docs',
    component: ComponentCreator('/en/ai-docs', '7b0'),
    exact: true
  },
  {
    path: '/en/download',
    component: ComponentCreator('/en/download', '164'),
    exact: true
  },
  {
    path: '/en/download/headless',
    component: ComponentCreator('/en/download/headless', 'f6b'),
    exact: true
  },
  {
    path: '/en/legal/agent-license',
    component: ComponentCreator('/en/legal/agent-license', 'e64'),
    exact: true
  },
  {
    path: '/en/legal/agent-privacy',
    component: ComponentCreator('/en/legal/agent-privacy', '644'),
    exact: true
  },
  {
    path: '/en/legal/privacy-policy',
    component: ComponentCreator('/en/legal/privacy-policy', '58c'),
    exact: true
  },
  {
    path: '/en/legal/user-agreement',
    component: ComponentCreator('/en/legal/user-agreement', '243'),
    exact: true
  },
  {
    path: '/en/search',
    component: ComponentCreator('/en/search', '62b'),
    exact: true
  },
  {
    path: '/en/web',
    component: ComponentCreator('/en/web', '64c'),
    exact: true
  },
  {
    path: '/en/docs',
    component: ComponentCreator('/en/docs', 'a30'),
    routes: [
      {
        path: '/en/docs',
        component: ComponentCreator('/en/docs', '1ef'),
        routes: [
          {
            path: '/en/docs/tags',
            component: ComponentCreator('/en/docs/tags', '235'),
            exact: true
          },
          {
            path: '/en/docs/tags/access-control',
            component: ComponentCreator('/en/docs/tags/access-control', '408'),
            exact: true
          },
          {
            path: '/en/docs/tags/basic-features',
            component: ComponentCreator('/en/docs/tags/basic-features', '662'),
            exact: true
          },
          {
            path: '/en/docs/tags/bookmarks',
            component: ComponentCreator('/en/docs/tags/bookmarks', 'dbe'),
            exact: true
          },
          {
            path: '/en/docs/tags/cross-network',
            component: ComponentCreator('/en/docs/tags/cross-network', '487'),
            exact: true
          },
          {
            path: '/en/docs/tags/device-management',
            component: ComponentCreator('/en/docs/tags/device-management', '083'),
            exact: true
          },
          {
            path: '/en/docs/tags/favorites',
            component: ComponentCreator('/en/docs/tags/favorites', 'be6'),
            exact: true
          },
          {
            path: '/en/docs/tags/file-filtering',
            component: ComponentCreator('/en/docs/tags/file-filtering', '293'),
            exact: true
          },
          {
            path: '/en/docs/tags/file-sharing',
            component: ComponentCreator('/en/docs/tags/file-sharing', '782'),
            exact: true
          },
          {
            path: '/en/docs/tags/file-tasks',
            component: ComponentCreator('/en/docs/tags/file-tasks', '283'),
            exact: true
          },
          {
            path: '/en/docs/tags/ftp',
            component: ComponentCreator('/en/docs/tags/ftp', 'c24'),
            exact: true
          },
          {
            path: '/en/docs/tags/link-sharing',
            component: ComponentCreator('/en/docs/tags/link-sharing', '96d'),
            exact: true
          },
          {
            path: '/en/docs/tags/mcp',
            component: ComponentCreator('/en/docs/tags/mcp', '2f0'),
            exact: true
          },
          {
            path: '/en/docs/tags/navigation',
            component: ComponentCreator('/en/docs/tags/navigation', '3fe'),
            exact: true
          },
          {
            path: '/en/docs/tags/network-management',
            component: ComponentCreator('/en/docs/tags/network-management', 'c3c'),
            exact: true
          },
          {
            path: '/en/docs/tags/notifications',
            component: ComponentCreator('/en/docs/tags/notifications', '793'),
            exact: true
          },
          {
            path: '/en/docs/tags/recent-items',
            component: ComponentCreator('/en/docs/tags/recent-items', 'c4d'),
            exact: true
          },
          {
            path: '/en/docs/tags/s3',
            component: ComponentCreator('/en/docs/tags/s3', '88c'),
            exact: true
          },
          {
            path: '/en/docs/tags/sftp',
            component: ComponentCreator('/en/docs/tags/sftp', '627'),
            exact: true
          },
          {
            path: '/en/docs/tags/smb',
            component: ComponentCreator('/en/docs/tags/smb', '9d4'),
            exact: true
          },
          {
            path: '/en/docs/tags/sync-management',
            component: ComponentCreator('/en/docs/tags/sync-management', 'd98'),
            exact: true
          },
          {
            path: '/en/docs/tags/webdav',
            component: ComponentCreator('/en/docs/tags/webdav', '8ce'),
            exact: true
          },
          {
            path: '/en/docs',
            component: ComponentCreator('/en/docs', 'e61'),
            routes: [
              {
                path: '/en/docs/category/教程---基础',
                component: ComponentCreator('/en/docs/category/教程---基础', '97f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/category/教程---进阶',
                component: ComponentCreator('/en/docs/category/教程---进阶', '927'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/intro',
                component: ComponentCreator('/en/docs/intro', 'fdc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/app_drawer/',
                component: ComponentCreator('/en/docs/tutorial-basics/app_drawer/', 'd8d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/bookmark/',
                component: ComponentCreator('/en/docs/tutorial-basics/bookmark/', '298'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/favorite/',
                component: ComponentCreator('/en/docs/tutorial-basics/favorite/', '760'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/file/',
                component: ComponentCreator('/en/docs/tutorial-basics/file/', '4f7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/filter/',
                component: ComponentCreator('/en/docs/tutorial-basics/filter/', '8c5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/filter/filter_manager_child/',
                component: ComponentCreator('/en/docs/tutorial-basics/filter/filter_manager_child/', '004'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/filter/filter_manager/',
                component: ComponentCreator('/en/docs/tutorial-basics/filter/filter_manager/', '20e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/home/',
                component: ComponentCreator('/en/docs/tutorial-basics/home/', 'afd'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/notification/',
                component: ComponentCreator('/en/docs/tutorial-basics/notification/', '8b5'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/recent/',
                component: ComponentCreator('/en/docs/tutorial-basics/recent/', 'bd8'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/task/',
                component: ComponentCreator('/en/docs/tutorial-basics/task/', 'd62'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-basics/toolbox/',
                component: ComponentCreator('/en/docs/tutorial-basics/toolbox/', '0a2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/device/',
                component: ComponentCreator('/en/docs/tutorial-extras/device/', 'b4f'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/device/device_manage/',
                component: ComponentCreator('/en/docs/tutorial-extras/device/device_manage/', 'd6a'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/device/device_permission/',
                component: ComponentCreator('/en/docs/tutorial-extras/device/device_permission/', '9b1'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/device/device_role/',
                component: ComponentCreator('/en/docs/tutorial-extras/device/device_role/', 'bd7'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/mcp/',
                component: ComponentCreator('/en/docs/tutorial-extras/mcp/', 'b2b'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/mcp/third-party-access/claude/',
                component: ComponentCreator('/en/docs/tutorial-extras/mcp/third-party-access/claude/', 'd5e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/mcp/third-party-access/codex/',
                component: ComponentCreator('/en/docs/tutorial-extras/mcp/third-party-access/codex/', '3a0'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/mcp/tools',
                component: ComponentCreator('/en/docs/tutorial-extras/mcp/tools', 'ec4'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/network/',
                component: ComponentCreator('/en/docs/tutorial-extras/network/', 'c8d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/network/FTP/',
                component: ComponentCreator('/en/docs/tutorial-extras/network/FTP/', 'f68'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/network/LinkShare/',
                component: ComponentCreator('/en/docs/tutorial-extras/network/LinkShare/', '7bc'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/network/S3/',
                component: ComponentCreator('/en/docs/tutorial-extras/network/S3/', 'af2'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/network/SFTP/',
                component: ComponentCreator('/en/docs/tutorial-extras/network/SFTP/', '629'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/network/SMB/',
                component: ComponentCreator('/en/docs/tutorial-extras/network/SMB/', 'a7e'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/network/WebDav/',
                component: ComponentCreator('/en/docs/tutorial-extras/network/WebDav/', '25c'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/share/',
                component: ComponentCreator('/en/docs/tutorial-extras/share/', 'd80'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/share/device/',
                component: ComponentCreator('/en/docs/tutorial-extras/share/device/', 'f98'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/share/file/',
                component: ComponentCreator('/en/docs/tutorial-extras/share/file/', 'fcf'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/share/http/',
                component: ComponentCreator('/en/docs/tutorial-extras/share/http/', 'b5d'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/sync/',
                component: ComponentCreator('/en/docs/tutorial-extras/sync/', '3aa'),
                exact: true,
                sidebar: "tutorialSidebar"
              },
              {
                path: '/en/docs/tutorial-extras/webrtc/',
                component: ComponentCreator('/en/docs/tutorial-extras/webrtc/', '31e'),
                exact: true,
                sidebar: "tutorialSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/en/',
    component: ComponentCreator('/en/', '6c2'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
